import gql from 'graphql-tag';

export const GetLoginUserSignup = gql`
	query GetLoginUser(
		$cognitoId: ID
		$accountClaim: AWSJSON
		$token: AWSJSON
		$emailAddress: String
		$employeeId: String
		$companyId: ID
	) {
		getLoginUser(
			cognitoId: $cognitoId
			accountClaim: $accountClaim
			token: $token
			emailAddress: $emailAddress
			employeeId: $employeeId
			companyId: $companyId
		) {
			id
		}
	}
`;
